import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Form, InputNumber } from 'tdesign-react';
import { updateTopicLimitPolicy } from '@/services/kopNamespaceService';
import { fetchProPolices } from '@/slices/kopNamespaceSlice';
import { isEmpty } from '@/utils/common';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';

const { FormItem } = Form;

function Modal({ visible, handleClose, detail, commonProps, fetchProPolices }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      form.reset();
      form.setFieldsValue(detail);
    }
  }, [form, visible, detail]);

  const onCancel = () => {
    handleClose();
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        await updateTopicLimitPolicy({
          ...commonProps,
          ...fields,
        });
        await fetchProPolices(commonProps);
        handleClose();
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      header='数量限制'
      width={550}
      onClose={onCancel}
    >
      <Form form={form} onSubmit={handleSubmit} style={{ width: '94%' }} labelWidth={140}>
        <FormItem
          name='topicLimit'
          rules={[{ validator: (val) => isEmpty(val) || val >= 0, message: '请输入不小于0的值' }]}
          label='最大Topic数'
        >
          <InputNumber theme='normal' decimalPlaces={0} />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect(null, {
  fetchProPolices,
})(Modal);
